import { render, staticRenderFns } from "./ConsultantContractAdmin.vue?vue&type=template&id=81c03730&"
import script from "./ConsultantContractAdmin.vue?vue&type=script&lang=ts&"
export * from "./ConsultantContractAdmin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports